"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderFile = void 0;
const common_1 = require("../../common");
const models_1 = require("../../file-management/models");
const sales_order_header_model_1 = require("./sales-order-header.model");
class SalesOrderFile extends common_1.MongoDocument {
}
exports.SalesOrderFile = SalesOrderFile;
//# sourceMappingURL=sales-order-file.model.js.map